<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { getCurrentInstance, onMounted } from 'vue';

import BookingWidget from '@/components/booking/BookingWidget.vue';
import { i18n } from '@/shared-instance.ts';
import { useGlobalConfigurationStore } from '@/stores/useGlobalConfigurationStore.ts';

const props = defineProps<{
  productId: string;
}>();

i18n.install(getCurrentInstance()!.appContext.app);

const configurationStore = useGlobalConfigurationStore();
const { globalConfiguration } = storeToRefs(configurationStore);

onMounted(() => {
  if (!globalConfiguration.value?.apikey) {
    throw new Error('global configuration for booking widget is missing');
  }
  if (!props.productId) {
    throw new Error('productId for booking widget is missing');
  }
});
</script>

<template>
  <BookingWidget :product-id="props.productId" />
</template>
